

import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import Preloader from "../Preloder/Preloader";
import "./cirtifact.css";

const Certificate = () => {
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/details/getCertificates`)
      .then((response) => {
        setCertificates(response.data);
      })
      .catch((error) => {
        console.error("Error fetching certificates:", error);
      });
  }, []);

  return (
    <div>
      <Header />
      <Preloader />

      <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container">
          <h2 className="page-header__title">Certificate</h2>
          <ul className="cleenhearts-breadcrumb list-unstyled">
            <li>
              <i className="icon-home"></i> <Link to="/">Home</Link>{" "}
            </li>
            <li>
              <span>Certificate</span>
            </li>
          </ul>
        </div>
      </section>

      <div className="certificate-container">
        {certificates.length > 0 ? (
          certificates.map((certificate) => {
            const fileUrl = `${process.env.REACT_APP_API}/uploads/SubCategories/Images/${certificate.file_name}`;

            return (
              <div key={certificate.id} className="certificate-card">
                <h3>{certificate.title}</h3>
                <p>{certificate.description}</p>
                
                <div className="certificate-actions">
                  {/* <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="view-pdf">
                    📄 View PDF
                  </a> */}


<a href={fileUrl} target="_blank" rel="noopener noreferrer">
  View PDF
</a>

                  
                  {/* ✅ Added Download Button */}
                  <a href={fileUrl} download={certificate.file_name} className="download-btn">
                    ⬇️ Download
                  </a>
                </div>
              </div>
            );
          })
        ) : (
          <p>No certificates available.</p>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Certificate;
